import { Box } from '@chakra-ui/react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';

import useGetHostSchedule from 'Domain/host/useGetHostSchedule';
import { Condition, Iteration } from 'Component/others';
import { TextMedium, TextSemiBold } from 'UiKit/typography';
import EmptyState from 'Component/empty-state';
import DataNotFound from 'Component/data-notfound';

import ScheduleCard from 'View/host/component/schedule-card';
import LoadMoreLoader from 'View/host-schedule/component/load-more-loader';
import SkeletonHostSchedule from 'View/host-schedule/component/skeleton';
import { useHostScheduleState } from 'View/host-schedule/state';

import styles from './styles.module.css';

const ScheduleList = () => {
  const { t } = useTranslation('empty-state', 'host-schedule');
  const { data, isFetching } = useGetHostSchedule();
  const { state, updateState, filterState, updateFilterState } = useHostScheduleState();

  const hasMoreData = data?.currentPage < data?.totalPage;
  const isShowLoadMoreLoader = isFetching && hasMoreData;
  const isShowSkeleton = isFetching && filterState?.page === 1;

  const onLoadMore = () => updateFilterState({ page: filterState?.page + 1 });
  const onChangeExpandedCard = (id) => updateState({ selectedExpandedCard: id });

  return (
    <Box className={'schedule-list__container'}>
      <InfiniteScroll dataLength={data?.dailySchedules?.length ?? 0} hasMore={hasMoreData} next={onLoadMore} scrollThreshold="80%">
        <Condition statement={!isShowSkeleton} fallback={<SkeletonHostSchedule />}>
          <Condition
            statement={data?.isDataExist}
            fallback={
              <EmptyState
                background={'var(--color-semantic-white)'}
                title={t('empty-state:no_data.title')}
                description={t('empty-state:no_data.description')}
              />
            }
          >
            <Condition
              statement={data?.dailySchedules?.length > 0}
              fallback={<DataNotFound background={'var(--color-semantic-white)'} fieldSearch={filterState?.search} />}
            >
              <Iteration
                items={data?.dailySchedules}
                render={({ schedules, date }, dailyIndex) => (
                  <Box className={styles['daily-schedule__container']} key={dailyIndex}>
                    <Box className={styles['head__section']}>
                      <TextSemiBold className={styles['daily-schedule__title']}>{date}</TextSemiBold>
                    </Box>

                    <Box className={styles['content__section']}>
                      <Condition
                        statement={schedules?.length}
                        fallback={<TextMedium className={styles['no-schedule__text']}>{t('host-schedule:page.no_schedule')}</TextMedium>}
                      >
                        <Iteration
                          items={schedules}
                          render={(schedule) => {
                            const isExpand = state?.selectedExpandedCard === schedule?.id;

                            return (
                              <ScheduleCard
                                onChangeExpandedCard={onChangeExpandedCard}
                                isExpand={isExpand}
                                isDefaultExpand={schedule?.isExpand}
                                key={schedule.id}
                                data={schedule}
                              />
                            );
                          }}
                        />
                      </Condition>
                    </Box>
                  </Box>
                )}
              />
            </Condition>
          </Condition>

          <Condition statement={isShowLoadMoreLoader}>
            <LoadMoreLoader />
          </Condition>
        </Condition>
      </InfiniteScroll>
    </Box>
  );
};

export default ScheduleList;
